import {isEmpty} from 'front-onceforall-core/dist/utils/arrays';

import documentTypeService from '../../../services/documentType/DocumentTypeService';
import collectionMandateService from '../../../services/collectionMandate/MandateService';
import broadcastMandateService from '../../../services/broadcastMandate/MandateService';
import subscriptionService from '../../../services/subscription/SubscriptionService';

function getCollectionMandates(organisationId) {
  return collectionMandateService.getMandates(organisationId)
    .then(response => {
      if (isEmpty(response)) {
        return response;
      }

      const subtypeCodes = response.map(mandate => mandate.subtypeCode);

      return documentTypeService.getBySubtypeCodes(subtypeCodes)
        .then(subtypes => {
          const mandates = response.map(mandate => ({
            ...mandate,
            subtypeName: subtypes.find(subtype => subtype.code === mandate.subtypeCode).name
          }));
          return {mandates};
        });
    });
}

function getBroadcastMandates(organisationId) {
  return Promise.all([
    subscriptionService.findSubscriptionByOrganisation(organisationId),
    broadcastMandateService.getMandates(organisationId)
  ])
    .then(([subscription, mandatesList]) => {
      const mandates = mandatesList.sort((a, b) => (a.platform > b.platform ? 1 : -1));
      return {
        mandates,
        broadcastMandateServiceAuthorized: subscription.broadcastMandateServiceAuthorized
      };
    });
}

export function getMandates(organisationId, isCollectionMandate) {
  return isCollectionMandate ? getCollectionMandates(organisationId) : getBroadcastMandates(organisationId);
}
